import { checkIsSameDay } from "lib/compareDates";
import getDaysAgo from "lib/getDaysAgo";
import getHoursAgo from "lib/getHoursAgo";

export function formatDateForDisplay(publishedAt: string): string {
  const isSameDate = checkIsSameDay(publishedAt);
  if (isSameDate) {
    const hoursAgo = getHoursAgo(publishedAt);
    if (hoursAgo === 0 || hoursAgo === 1) {
      return hoursAgo + " hour ago";
    }
    return hoursAgo + " hours ago";
  }
  const daysAgo = getDaysAgo(publishedAt);
  if (daysAgo === 0 || daysAgo === 1) {
    return 1 + " day ago";
  } else if (daysAgo === 2) {
    return daysAgo + " days ago";
  }
  const localFormatted = new Date(publishedAt).toLocaleDateString();
  return localFormatted;
}
